import { render } from "./JudgingProgramView.vue?vue&type=template&id=d12a848a&scoped=true"
import script from "./JudgingProgramView.vue?vue&type=script&lang=js"
export * from "./JudgingProgramView.vue?vue&type=script&lang=js"

import "./JudgingProgramView.vue?vue&type=style&index=0&id=d12a848a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d12a848a"]])

export default __exports__